import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var CheckBoxStyle = function CheckBoxStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  return css([".c7n-pro-checkbox-button .c7n-pro-checkbox:disabled:checked + i + .c7n-pro-checkbox-label{&,&:hover{background:", ";border-color:", ";color:#fff;opacity:0.6;}}"], primary, primary);
};
export default CheckBoxStyle;